<template>
  <div class="flex flex-col items-center justify-center py-12">
    <div class="relative">
      <!-- Main spinner -->
      <svg
        class="animate-spin h-16 w-16 text-primary-600"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          class="opacity-10"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          stroke-width="4"
        ></circle>
        <path
          class="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>

      <!-- Musical note that pulses in the center -->
      <div class="absolute inset-0 flex items-center justify-center">
        <svg
          class="h-6 w-6 text-primary-700 animate-pulse"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            d="M18 3a1 1 0 00-1.196-.98l-10 2A1 1 0 006 5v9.114A4.369 4.369 0 005 14c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V7.82l8-1.6v5.894A4.37 4.37 0 0015 12c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V3z"
          />
        </svg>
      </div>
    </div>

    <p class="mt-4 text-gray-500 font-medium text-center animate-pulse">
      <slot>Loading...</slot>
    </p>
  </div>
</template>

<script>
export default {
  name: "LoadingState",
};
</script>
